var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35254 13.8799C7.12695 13.8799 6.78516 13.6816 6.4707 13.4766C2.71094 11.0225 0.243164 8.09668 0.243164 5.16406C0.243164 2.47754 2.10938 0.672852 4.35156 0.672852C5.74609 0.672852 6.75781 1.44531 7.35254 2.55957C7.9541 1.43848 8.96582 0.672852 10.3604 0.672852C12.6025 0.672852 14.4688 2.47754 14.4688 5.16406C14.4688 8.09668 12.001 11.0225 8.24121 13.4766C7.92676 13.6816 7.58496 13.8799 7.35254 13.8799Z",
    fill: "#FAFF02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.4924d9b81d0a96d8d9320f512753cdf9.svg";
export { ForwardRef as ReactComponent };